import {createContext, useState} from "react";

export const TimezoneContext = createContext("");

export const TimezoneProvider = ({children, timezoneStore}) => {
    const [timezone, setTimezone] = useState(timezoneStore.getApplicationTimezone());

    const updateTimezone = (newTimezone) => {
        setTimezone(newTimezone);
        timezoneStore.setApplicationTimezone(newTimezone);
    };

    return (
        <TimezoneContext.Provider value={{ timezone, updateTimezone, timezoneStore }}>
            {children}
        </TimezoneContext.Provider>
    )
}
